import {RagState} from "./components/ComparisonSummary";

export const colors: Record<RagState, string> = {
  red: "#FF0000",
  amber: "#ff8800",
  green: "#00c853",
};
